var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcons16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #99844e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.85,471.01c82.83,162.6,215.12,294.73,377.87,377.45l126.17-126.44c15.82-15.82,38.38-20.33,58.21-14.03,64.06,21.18,133.21,32.68,204.57,32.68,31.8,0,57.33,25.53,57.33,57.33v200.67c0,31.8-25.53,57.33-57.33,57.33C460.27,1056,24,619.73,24,81.33c0-31.65,25.69-57.33,57.33-57.33h200.67c31.8,0,57.33,25.53,57.33,57.33,0,71.36,11.5,140.51,32.68,204.68,6.31,19.72,1.8,42.43-14.03,58.25l-126.13,126.75h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcons16);
export default __webpack_public_path__ + "static/media/contact_icons-16.25a1fb01aa63ff7825a57d09e5b94ca1.svg";
export { ForwardRef as ReactComponent };